import React from 'react'
import HeroSection from "./HeroSection";
import MultitabComp from "./MultitabComp";
import FeaturesComp from "./FeaturesComp";
import UsecaseComp from "./UsecaseComp";
import CoreValues from './CoreValues';
import FAQComp from './FAQComp';
import PromoBanner from './PromoBanner';

const Home = () => {
  return (
    <>
      <HeroSection/>
      <MultitabComp/>
      <FeaturesComp/>
      <UsecaseComp/>
      <CoreValues/>
      <FAQComp/>
      <PromoBanner/>
    </>
  )
}

export default Home